module.exports = __webpack_public_path__ + "static/media/last.3f2e1622.svg";